<template>
  <asc-page-loading-indicator
    :loading="
      (allAnalyticModulesLoading || allAnalyticsLoading) &&
      !apiPageFailure.length
    "
  >
    <div class="asc-analytic-container">
      <asc-container>
        <template slot="header"
          ><asc-surface-title title="ANALYTIC MANAGEMENT"
        /></template>
        <asc-analytic-grid-template
          title="Analytic Management"
          :values="mappedAnalyticModules"
          :grid-filters="gridFilters"
          :on-open="handleOpenDialog"
        ></asc-analytic-grid-template>

        <asc-analytic-dialog
          :show-dialog="analyticDialogVisible && !apiPageFailure.length"
          :name="title"
          :on-close="handleCloseDialog"
          :components="componentsData"
          :airlines="activeAirlines"
          :ata-chapter-list="mappedLuAtaChapters"
          :analytic-details="analyticModule"
          :loading-wrapper="isAnalyticDetailsLoading && !apiPageFailure.length"
          :loading-button="isSaveAnalyticsLoading && !apiPageFailure.length"
          :features="allFeaturesByModule"
          :alert-types="allAlertTypesByModule"
          :issue-types="issueTypes"
          :all-analytics="allAnalytics"
          @updateClick="handleUpdateClick"
        ></asc-analytic-dialog>

        <asc-confirmation
          v-if="saveModuleToastNotification && toastDisplayed"
          :definition="definition"
          :on-close="closeToastNotification"
        ></asc-confirmation>
      </asc-container>
    </div>
  </asc-page-loading-indicator>
</template>

<script>
import AscPageLoadingIndicator from '@/components/molecules/AscPageLoadingIndicator'
import AscAnalyticGridTemplate from '@/components/templates/AscAnalyticGridTemplate'
import { mapState, mapActions, mapGetters } from 'vuex'
import {
  ANALYTIC_MANAGEMENT_CONSTS as AMC,
  FEATURE_CONSTS as FEA,
  ALERT_TYPE_CONSTS as ATC,
  ANALYTIC_MODULE_CONSTS as AC,
  LOOKUP_CONSTS as LC,
  ISSUE_TYPE_CONSTS as ITC,
  ADMIN_CONSTS as ADMC,
  AIRLINE_MANAGEMENT_CONSTS as AOC,
} from '@/stores/consts'
import AscAnalyticDialog from '@/components/molecules/AscAnalyticDialog'
import AscConfirmation from '@/components/molecules/AscConfirmation'
import AscSurfaceTitle from '@/components/atoms/AscSurfaceTitle'
import AscContainer from '@/components/atoms/AscContainer'

export default {
  name: 'AscAnalyticContainer',

  components: {
    AscPageLoadingIndicator,
    AscAnalyticGridTemplate,
    AscAnalyticDialog,
    AscConfirmation,
    AscSurfaceTitle,
    AscContainer,
  },

  props: {
    gridFilters: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      analyticDialogVisible: false,
      title: '',
      toastDisplayed: false,
      isAnalyticDetailsLoading: false,
      allAnalyticsLoading: false,
      isSaveAnalyticsLoading: false,
      definition: [
        {
          mode: 'toast',
          type: 'success',
          text: 'Analytic Details Saved Successfully',
          dismissible: true,
          hasToastAction: false,
          autoClose: true,
        },
      ],
    }
  },

  computed: {
    ...mapState({ apiPageFailure: 'apiPageFailure' }),
    ...mapState(AMC.NAMESPACE, ['analyticsData', 'analyticDetails']),
    ...mapState(AC.NAMESPACE, [
      'analyticModules',
      'analyticModule',
      'allAnalyticModulesLoading',
      'saveModuleToastNotification',
    ]),
    ...mapState(LC.NAMESPACE, ['masterModels']),
    ...mapState(FEA.NAMESPACE, ['allFeaturesByModule']),
    ...mapState(ATC.NAMESPACE, ['allAlertTypesByModule']),
    ...mapState(ITC.NAMESPACE, ['issueTypes']),
    ...mapState(ADMC.NAMESPACE, ['adminMasterModels']),
    ...mapState(AOC.NAMESPACE, ['allAirlines']),
    ...mapGetters(LC.NAMESPACE, ['mappedLuAtaChapters']),
    allAnalytics() {
      return this.analyticsData.analyticCombinedData
    },
    componentsData() {
      return this.analyticsData.components
    },
    activeAirlines() {
      return this.allAirlines.filter(item => item.isActive)
    },
    mappedAnalyticModules() {
      if (
        this.analyticModules &&
        this.adminMasterModels?.length &&
        this.componentsData?.length
      ) {
        return this.analyticModules.map(item => {
          const platform = this.adminMasterModels.find(
            model => model.masterModelId === item.masterModelId,
          )
          const component = this.componentsData.find(
            component => component.id === item.componentId,
          )
          return {
            ...item,
            masterModelName: platform === undefined ? '' : platform.text,
            componentName: component === undefined ? '' : component.name,
          }
        })
      }
      return []
    },
  },

  created() {
    this.getAnalyticData()
    this.getAtaChapterList()
  },

  methods: {
    ...mapActions(AMC.NAMESPACE, [AMC.GET_ALL_ANALYTICS]),
    ...mapActions(FEA.NAMESPACE, [
      FEA.GET_ALL_FEATURES_BY_MODULE,
      FEA.SAVE_FEATURE,
    ]),
    ...mapActions(ATC.NAMESPACE, [
      ATC.GET_ALL_ALERT_TYPES_BY_MODULE,
      ATC.SAVE_ALERT_TYPE,
    ]),
    ...mapActions(AC.NAMESPACE, [
      AC.GET_ANALYTIC_MODULES,
      AC.GET_ANALYTIC_MODULE,
      AC.SAVE_ANALYTIC_MODULE,
    ]),
    ...mapActions(ITC.NAMESPACE, [ITC.GET_ISSUE_TYPES]),
    ...mapActions(LC.NAMESPACE, [LC.GET_MASTER_MODELS]),
    ...mapActions(LC.NAMESPACE, [LC.GET_ATA_CHAPTERS]),
    ...mapActions(ADMC.NAMESPACE, [ADMC.GET_ADMIN_MASTER_MODELS]),
    ...mapActions(AOC.NAMESPACE, [AOC.GET_ALL_AIRLINES]),
    async getAnalyticData() {
      this.allAnalyticsLoading = true
      await Promise.all([
        this[AMC.GET_ALL_ANALYTICS](),
        this[AC.GET_ANALYTIC_MODULES](true),
        this[LC.GET_MASTER_MODELS](),
        this[ITC.GET_ISSUE_TYPES](),
        this[ADMC.GET_ADMIN_MASTER_MODELS](),
        this[AOC.GET_ALL_AIRLINES](),
      ])
      this.allAnalyticsLoading = false
    },
    async handleOpenDialog(item) {
      this.isAnalyticDetailsLoading = true
      this.title = item.interalName
      this.analyticDialogVisible = true
      await Promise.all([
        this[AC.GET_ANALYTIC_MODULE]({ id: item.id, isAdmin: true }),
        this[FEA.GET_ALL_FEATURES_BY_MODULE]({ id: item.id, isAdmin: true }),
        this[ATC.GET_ALL_ALERT_TYPES_BY_MODULE]({ id: item.id, isAdmin: true }),
      ])
      this.isAnalyticDetailsLoading = false
    },
    handleCloseDialog() {
      this.analyticDialogVisible = false
    },
    async handleUpdateClick(data) {
      this.isSaveAnalyticsLoading = true
      if (data.features.length) {
        await Promise.all([
          data.features.forEach(item => {
            this[FEA.SAVE_FEATURE](item)
          }),
        ])
      }
      if (data.alerts.length) {
        await Promise.all([
          data.alerts.forEach(item => {
            this[ATC.SAVE_ALERT_TYPE](item)
          }),
        ])
      }
      const newModuleDetails = {
        ...data.details,
        primaryComponentId: data.details.componentId,
      }
      await Promise.all([this[AC.SAVE_ANALYTIC_MODULE](newModuleDetails)])
      this.isSaveAnalyticsLoading = false
      this.analyticDialogVisible = false
      this.toastDisplayed = true
    },
    closeToastNotification() {
      this.toastDisplayed = false
    },
    async getAtaChapterList() {
      await this[LC.GET_ATA_CHAPTERS]()
    },
  },
}
</script>
